import React, { useState } from 'react';

import {
  AppBar,
  Avatar,
  Backdrop,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Slide,
  Stack,
  TextField,
  Toolbar,
  Typography
} from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';

import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ShortcutIcon from '@mui/icons-material/Shortcut';
import StorageIcon from '@mui/icons-material/Storage';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';

import Autodesk from 'assets/images/auth/autodesk.webp';
import Excel from 'assets/images/auth/excel.png';
import Redas from 'assets/images/auth/redas_result.webp';
import SGBuildex from 'assets/images/auth/sgbuildex_result.webp';
import GoogleDrive from 'assets/images/auth/googledrive_result.webp';

import GoogleListItemMigrationDialog from '../../components/googleDrive/googleListItemsMigration';
import ListConnectorsDialog from '../../components/listConnectors';
import useMigrateStore from '../../store/useMigrate';
import HubPage from './hub';
import { renderLabelProvider } from '../../utils/utils';
import { useMigrationData } from '../../hooks/useMigration';
import SnackbarAlert from '../../components/alert/alertSnackbar';
import ScheduleFormDialog from './schedule/scheduleForm';
import ScheduleMigrationPage from './schedule';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const items = [
  { img: Excel, title: 'Integrasia Utama' },
  { img: Autodesk, title: 'Bimage' },
  { img: SGBuildex, title: 'SgBuildex111' },
  { img: Redas, title: 'redaspiuser' }
];

const END_ICONS = {
  folders: <FolderOutlinedIcon fontSize="small" />,
  items: <Inventory2Icon fontSize="small" />
};

function PathBreadcrumb({ data }) {
  return (
    <Breadcrumbs separator="›" aria-label="path">
      {data?.path_data.map((node, index) => {
        const isLast = index === data?.path_data.length - 1;
        const endIcon = isLast ? END_ICONS[data.type] : null;

        return isLast ? (
          <Stack key={node.name} direction="row" alignItems="center" spacing={0.5}>
            <Typography color="text.primary" fontWeight={500}>
              {node.name}
            </Typography>
            {endIcon}
          </Stack>
        ) : (
          <Link key={node.name} underline="hover" color="inherit">
            {node.name}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}

export default function MigrationPage() {
  const {
    hubname,
    openProject,
    sourceProviderData,
    destinationProviderData,
    setCloseProject,
    setHubName,
    choosenFolderSource,
    choosenFolderDestination,
    handleSourceProviderData,
    handleDestinationProviderData,
    handleFolderMode
  } = useMigrateStore();
 
  const { mutate: migrateData, isPending: isMigrateData } = useMigrationData();

  // console.log({});
  const [openConnectors, setopenConnectos] = useState(false);
  const [connectors, setconnectors] = useState(null);
  const [openGoogleDrive, setopenGoogleDrive] = useState(false);
  const [openHub, setopenHub] = useState(false);
  const [openSchedule, setopenSchedule] = useState(false)

  const [snackbar, setSnackbar] = useState({
    open: false,
    title: '',
    content: '',
    type: 'error'
  });

  const handleCloseSnackbar = () => {
    setSnackbar({
      open: false,
      title: '',
      content: '',
      type: 'error'
    });
  };

  const handleAddSource = () => {
    handleFolderMode('source');
    setopenConnectos(true);
  };

  const handleAddDestination = () => {
    handleFolderMode('destination');
    setopenConnectos(true);
  };

  const handleCloseConnectors = () => {
    setopenConnectos(false);
  };

  const handleSelectConnectors = (param) => {
    const { provider, id, metadata, label } = param;
    console.log(param);
    setopenConnectos(false);
    setTimeout(() => {
      setconnectors(param);
      if (provider === 'redas') {
      }

      if (provider === 'autodesk') {
        setopenHub(true);
      }

      if (provider === 'googledrive') {
        setopenGoogleDrive(true);
      }
    }, 200);
  };

  const handleCloseGoogleDialog = () => {
    setopenGoogleDrive(false);
  };

  const runMigration = ({ destinationPayload, afterSuccess, beforeRun }) => {
    if (beforeRun) beforeRun();

    const payload = {
      item_type: sourceProviderData.type,
      source: sourceProviderData,
      destination: destinationPayload
    };

    const sourceProvider = renderLabelProvider[sourceProviderData.provider];
    const sourceDestination = renderLabelProvider[destinationPayload.provider];

    migrateData(payload, {
      onSuccess: () => {
        handleSourceProviderData(null);
        handleDestinationProviderData(null);
        afterSuccess({
          sourceProvider,
          sourceDestination
        });
      },
      onError: (error) => {
        // console.error('MUTATION ERROR', error);
      }
    });
  };

  const handleConfirmGoogleDialog = ({ payload, param }) => {
    console.log(param);
    setopenGoogleDrive(false);
    if (param == "upload") {
      runMigration({
        destinationPayload: payload,

        beforeRun: () => {
          setopenGoogleDrive(false);
        },

        afterSuccess: ({ sourceProvider, sourceDestination }) => {
          setTimeout(() => {
            setSnackbar({
              open: true,
              title: 'Migration Data success',
              content: `You Successfully migrate data from ${sourceProvider} to ${sourceDestination}`,
              type: 'success'
            });
          }, 500);
        }
      });
    } 
    if (param == "schedule") {
      setopenSchedule(true)
    }
  };

  const handleCloseAccDialog = () => {
    setCloseProject(false);
    setopenHub(false);
  };

  const handleConfirmAccDialog = ({ payload, param }) => {
    console.log(param)
    setCloseProject(false);
    setopenHub(false);
    if (param == "upload") {
      runMigration({
        destinationPayload: payload,

        beforeRun: () => {
          setCloseProject(false);
          setopenHub(false);
        },

        afterSuccess: ({ sourceProvider, sourceDestination }) => {
          setTimeout(() => {
            setSnackbar({
              open: true,
              title: 'Migration Data success',
              content: `You Successfully migrate data from ${sourceProvider} to ${sourceDestination}`,
              type: 'success'
            });
          }, 500);
        }
      });
    }
    if (param == "schedule") {
      setopenSchedule(true)
    }
    
  };

  const handleBackHub = () => {
    setHubName('');
    setCloseProject(false);
  };

  const handleCloseFormModal = () => setopenSchedule(false);
  const handleConfirmFormModal = (source, destination) => {
    const sourceProvider = renderLabelProvider[source.provider];
    const sourceDestination = renderLabelProvider[destination.provider];
    setTimeout(() => {
      setSnackbar({
        open: true,
        title: 'Create Schedule Migration success',
        content: `You Successfully create schedule migrate data from ${sourceProvider} to ${sourceDestination}`,
        type: 'success'
      });
    }, 500);
    setopenSchedule(false)
  };

  return (
    <>
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
        open={isMigrateData}
        // onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {snackbar.open && <SnackbarAlert open={snackbar.open} handleClose={handleCloseSnackbar} message={snackbar} />}
      <Box sx={{ p: 4 }}>
        {/* TOP: Source & Destination */}
        <Grid container spacing={4} justifyContent={'center'}>
          {/* SOURCE */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                width: '100%',
                height: '100%',
                borderRadius: 3
              }}
            >
              <Stack spacing={2}>
                <Box display="flex" alignItems="center" gap={1.5}>
                  <StorageIcon color="primary" />
                  <Typography variant="h6" fontWeight="bold">
                    Source
                  </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary">
                  Select and configure your source data.
                </Typography>

                <Divider />
                <Typography color="text.secondary" sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', gap: 1 }}>
                  Selected Source :
                  <Typography component="span" fontWeight="bold" color="text.primary">
                    {renderLabelProvider[sourceProviderData?.provider] || '-'}
                  </Typography>
                </Typography>
                {sourceProviderData && <PathBreadcrumb data={sourceProviderData} />}
                <Button sx={{ mt: 2 }} variant="outlined" fullWidth onClick={handleAddSource}>
                  Select Source
                </Button>
              </Stack>
            </Paper>
          </Grid>

          {/* TRANSFORM ICON */}
          <Grid size={{ xs: 12, md: 2 }} display="flex" alignItems="center" justifyContent="center">
            <ShortcutIcon
              sx={{
                fontSize: 60,
                color: 'primary.main'
              }}
            />
          </Grid>

          {/* DESTINATION */}
          <Grid size={{ xs: 12, md: 5 }}>
            <Paper
              elevation={3}
              sx={{
                p: 3,
                width: '100%',
                height: '100%',
                borderRadius: 3
              }}
            >
              <Stack spacing={2}>
                <Box display="flex" alignItems="center" gap={1.5}>
                  <CloudUploadIcon color="success" />
                  <Typography variant="h6" fontWeight="bold">
                    Destination
                  </Typography>
                </Box>

                <Typography variant="body2" color="text.secondary">
                  Choose where the data will be stored.
                </Typography>

                <Divider />

                <Typography color="text.secondary" sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', gap: 1 }}>
                  Selected Source :
                  <Typography component="span" fontWeight="bold" color="text.primary">
                    {renderLabelProvider[destinationProviderData?.provider] || '-'}
                  </Typography>
                </Typography>
                {destinationProviderData && <PathBreadcrumb data={destinationProviderData} />}
                <Button sx={{ mt: 2 }} variant="outlined" fullWidth color="success" onClick={handleAddDestination}>
                  Select Destination
                </Button>
              </Stack>
            </Paper>
          </Grid>
        </Grid>

        {/* BOTTOM: Schedule Migration */}
        <Box mt={5} display="flex" justifyContent="center">
          <Paper
            elevation={4}
            sx={{
              p: 4,
              width: '100%',
              // maxWidth: 520,
              borderRadius: 3
            }}
          >
            <Stack spacing={3} alignItems="center">
              <Box display="flex" alignItems="center" gap={1}>
                <ScheduleIcon color="warning" />
                <Typography variant="h6" fontWeight="bold">
                  Schedule Migration
                </Typography>
              </Box>

              {/* <Typography variant="body2" color="text.secondary" align="center">
              No Schedule Migration Found
            </Typography> */}

              <ScheduleMigrationPage />

              {/* <Button
              variant="contained"
              size="large"
              startIcon={<ScheduleIcon />}
              sx={{ px: 4 }}
            >
              Schedule Now
            </Button> */}
            </Stack>
          </Paper>
        </Box>

        {openConnectors && (
          <ListConnectorsDialog
            open={openConnectors}
            onCancel={handleCloseConnectors}
            onConfirm={(param) => handleSelectConnectors(param)}
          />
        )}

        {openGoogleDrive && (
          <GoogleListItemMigrationDialog
            dataConnection={connectors}
            open={openGoogleDrive}
            onCancel={handleCloseGoogleDialog}
            onConfirm={(param) => handleConfirmGoogleDialog(param)}
          />
        )}

        <Dialog
          fullScreen
          open={openHub}
          onClose={handleCloseAccDialog}
          slots={{
            transition: Transition
          }}
        >
          <AppBar sx={{ position: 'relative' }}>
            <Toolbar>
              {openProject && (
                <IconButton edge="start" color="inherit" onClick={handleBackHub} aria-label="close">
                  <ArrowBackIcon />
                </IconButton>
              )}
              <Typography sx={{ ml: 2, flex: 1, fontWeight: 'bold' }} variant="h5" component="div">
                {openProject ? `Hub ${hubname}` : 'Choose Hub'}
              </Typography>
              <Button autoFocus color="inherit" onClick={handleCloseAccDialog}>
                CLOSE
              </Button>
            </Toolbar>
          </AppBar>
          <HubPage onConfirm={handleConfirmAccDialog} />
        </Dialog>
      </Box>
      <ScheduleFormDialog open={openSchedule} onClose={handleCloseFormModal} onConfirm={handleConfirmFormModal}/>
    </>
  );
}
